import { AbstractBlock } from '../AbstractBlock';
import { ColorSettings } from '../setting/ColorSettings';
import { ShapeSettings } from '../setting/ShapeSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { GlobalImport } from '../../utils/GlobalImport';
import { BlockType } from '../../@types/BlockType';
import { block_translation } from '../../lang/BlockTranslation';
const Blockly = GlobalImport.getBlockly();

const t = block_translation;

export class ZoomElement extends AbstractBlock {
  constructor() {
    super('zoom-element', 'zoom-element');
    this.setNameForCode('a-entity');
    const VERSION_NUMBER = '2.17.0';
    this.setLibrary(`https://source.zoom.us/${VERSION_NUMBER}/lib/vendor/react.min.js`);
    this.setLibrary(`https://source.zoom.us/${VERSION_NUMBER}/lib/vendor/react-dom.min.js`);
    this.setLibrary(`https://source.zoom.us/${VERSION_NUMBER}/lib/vendor/redux.min.js`);
    this.setLibrary(`https://source.zoom.us/${VERSION_NUMBER}/lib/vendor/redux-thunk.min.js`);
    this.setLibrary(`https://source.zoom.us/${VERSION_NUMBER}/lib/vendor/lodash.min.js`);
    // this.setLibrary(`https://source.zoom.us/zoom-meeting-${VERSION_NUMBER}.min.js`);
    this.setLibrary(`https://source.zoom.us/zoom-meeting-embedded-${VERSION_NUMBER}.min.js`);
  }

  defineBlock(block: BlockType): void {
    ColorSettings.setSceneColor(block);
    ShapeSettings.setElementShape(block);
    ShapeSettings.setTitleField(block, this.title);

    const meetingNumberString = t.to('Zoom ミーティングナンバー', 'zoom_meeting_number');
    const meetingNumber = new Blockly.FieldTextInput(meetingNumberString);
    block.appendDummyInput().appendField(meetingNumber, 'meetingNumber');

    // const meetingPasswordString = t.to('Zoom ミーティングパスワード', 'zoom_meeting_password');
    // const meetingPassword = new Blockly.FieldTextInput(meetingPasswordString);
    // block.appendDummyInput().appendField(meetingPassword, 'meetingPassword');
    ShapeSettings.addAttributeInput(block);
  }

  generateAfterbodyJavaScriptCode(block: BlockType): string {
    const code = `
    const zoomConnect = (userName,role) =>{
      const meetingNumber = document.getElementById('meetingNumber').value;

      const password = prompt("${t.to(
        'ミーティングパスワードを入力してください。設定されていない場合は空白',
        'title_to_set_zoom_password'
      )}")
      console.log("zoomConnect called")
      const client = ZoomMtgEmbedded.createClient();
      let meetingSDKElement = document.getElementById('meetingSDKElement');
      client.init({ zoomAppRoot: meetingSDKElement, language: 'jp-JP'});
      fetch('/v1/ZoomService/getSignature?0=' + meetingNumber+ '&1=' + role ).then(response => response.json()).then( json => {
        const responseJson = json.data;
        client.join({
          sdkKey: responseJson.sdkKey,
          signature: responseJson.signature,
          meetingNumber: meetingNumber,
          password: password,
          userName: userName,
        })
      })
    }`;
    return code;
  }

  codeGenerateCore(block: BlockType): string {
    /**
     * Zoomコンポーネントを表示するためのエレメント
     */
    let zoom_el_attribute = '';
    zoom_el_attribute += CodeSetting.getAttributeCode('id', 'meetingSDKElement');
    zoom_el_attribute += CodeSetting.getAttributeCode(
      'style',
      'position:absolute;top:5rem; left:5rem;z-index:10000'
    );
    let dom = CodeSetting.getElementCode('div', zoom_el_attribute, 'meetingSDKElement', '');

    /**
     * ミーティング番号を画面上に保持するHiddenを作成
     */
    const zoom_meeting_number = CodeSetting.getFieldValue(block, 'meetingNumber');
    let mn_attribute = '';
    mn_attribute += CodeSetting.getAttributeCode('id', 'meetingNumber');
    mn_attribute += CodeSetting.getAttributeCode('type', 'hidden');
    mn_attribute += CodeSetting.getAttributeCode('value', zoom_meeting_number);
    dom += CodeSetting.getElementCode('input', mn_attribute, 'meetingNumber', '');

    // *****
    // ZoomTest用ぼたんの生成コード
    // *****
    let btnAtt = CodeSetting.getAttributeCode('onclick', `zoomConnect('abc',0)`);
    btnAtt += CodeSetting.getAttributeCode(
      'style',
      'position:absolute;top:10rem; left:2rem; z-index:10001'
    );
    btnAtt += CodeSetting.getAttributeCode('type', 'button');
    btnAtt += CodeSetting.getAttributeCode('value', 'zoom');
    dom += CodeSetting.getElementCode('input', btnAtt, 'zoomBtn', '');
    return dom;
  }
}
